<div class="d-flex justify-content-start" id="custom-buttons">
  <button class="btn btn-secondary-dark btn-sm rounded-small text-xxs shadow text-dark mb-2 mt-2" data-bs-toggle="modal"
    data-bs-target="#create_section">
    Create Sections
  </button>
</div>
<!-- Table for Create Sections -->
<GlobalTable v-if="section_list.length > 0" :headers="section_table_headers" :data="table_safe_section_list"
  table_id="section_management_table">
  <template #actions="{ row }">
    <button class="btn btn-secondary-dark btn-sm rounded-small text-xxs shadow text-dark me-2"
      @click="open_edit_section_modal(row)" data-bs-toggle="modal" data-bs-target="#edit_section_modal">
      Edit
    </button>
    <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-white" @click="delete_section(row.id)">
      Delete
    </button>
    <button class="btn btn-secondary-dark btn-sm rounded-small text-xxs shadow text-dark ms-1"
      @click="open_assign_modal(row.id)" data-bs-toggle="modal" data-bs-target="#assign_questions_modal">
      Assign
    </button>
  </template>
</GlobalTable>

<!-- Assign Questions Modal -->
<teleport to="body">
<div class="modal fade" id="assign_questions_modal" tabindex="-1" aria-labelledby="assign_questions_modal_label"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="assign_questions_modal_label">
          Assign Questions
        </p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body py-3">
        <div class="card mb-4 border-0 shadow-none">
          <div class="card-body p-0">
            <div v-if="is_loading_questions" class="text-center py-4">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="text-muted mt-2 fs-6">Loading questions...</p>
            </div>
            <div v-else>
              <div class="d-flex justify-content-between align-items-center mb-3">
                <p class="text-muted mb-0 fs-6">
                  Toggle to assign or unassign questions to this section.
                </p>
                <div class="input-group input-group-sm w-auto">
                  <input type="text" class="form-control" placeholder="Search questions..." v-model="question_search">
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-bordered table-hover align-middle" id="assign_questions_table">
                  <thead class="table-header text-white">
                    <tr class="text-x">
                      <th class="text-center w-auto">Assign</th>
                      <th>Question</th>
                      <th>Type</th>
                      <th>Number</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="q in filtered_questions" :key="q.id" class="text-xxs">
                      <td class="text-center">
                        <!-- Bootstrap 5 Switch -->
                        <div class="form-check form-switch d-flex justify-content-center">
                          <input class="form-check-input" type="checkbox" role="switch" :id="'toggle-' + q.id"
                            :checked="q.is_assigned" :disabled="q.is_loading" @change="on_toggle_assign(q)">
                        </div>
                      </td>
                      <td>{{ q.question_text || 'No question text' }}</td>
                      <td>{{ format_question_type(q.question_type?.question_type || q.question_type) }}</td>
                      <td>{{ q.id }}</td>
                      <td>
                        <span class="badge" :class="{
                            'bg-success': q.is_assigned,
                            'bg-secondary': !q.is_assigned
                          }">
                          {{ q.is_assigned ? 'Assigned' : 'Unassigned' }}
                        </span>
                      </td>
                    </tr>
                    <tr v-if="filtered_questions.length === 0 && !is_loading_questions">
                      <td colspan="5" class="text-center py-3 text-muted fs-6">
                        {{ question_list.length === 0 ? 'No questions available' : 'No matching questions found' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-flex justify-content-between align-items-center mt-3">
                <div>
                  <small class="text-muted fs-6">
                    Showing {{ filtered_questions.length }} of {{ question_list.length }} questions
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</teleport>


<!-- Create Sections Modal -->
<teleport to="body">
<div class="modal fade" id="create_section" tabindex="-1" aria-labelledby="create_section_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="create_project_label">Create Section</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <!-- Section Name -->
        <div class="modal-form-group form-group mb-3">
          <label for="section_name" class="modal-form-label form-label text-xxs">Section Name:</label>
          <input type="text" v-model="section_name"
                 class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm text-x"
                 placeholder="Enter Section Name Here">
          <small v-if="section_name_error" class="text-danger p-2 text-xxs fw-bold">
            Please enter a section name
          </small>
        </div>

        <!-- Main Section Dropdown -->
        <div class="modal-form-group form-group mb-3">
          <label for="main_section_id" class="modal-form-label form-label text-xxs">Select Main Section:</label>
          <select v-model="selected_main_section_id"
                  class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm text-x">
            <option value="" disabled selected>-- Please select a main section --</option>
            <option v-for="main_section in main_sections"
                    :key="main_section.id"
                    :value="main_section.id">
              {{ main_section.name }}
            </option>
          </select>
          <small v-if="main_section_error" class="text-danger p-2 text-xxs fw-bold">
            Please select a main section
          </small>
        </div>
      </div>

      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button"
                class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                @click="create_section"
                data-bs-dismiss="modal">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>

<!-- Edit Section Modal -->
 <teleport to="body">
<div class="modal fade" id="edit_section_modal" tabindex="-1" aria-labelledby="edit_section_modal_label"
  aria-hidden="true" :class="{'show d-block': show_edit_section_modal}">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs">Edit Section</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"
          @click="show_edit_section_modal = false"></button>
      </div>
      <div class="modal-body">
        <div class="modal-form-group form-group mb-3">
          <label for="section_name" class="modal-form-label form-label text-xxs">Section Name:</label>
          <input type="text" id="section_name" v-model.trim="current_edit_section.name"
            :class="{'is-invalid': section_name_error}" @input="section_name_error = false"
            class="modal-form-control form-control text-xxs rounded-3 p-2 shadow-sm mb-3" placeholder="Section Name"
            required @keyup.enter="save_edited_section">
          <div v-if="section_name_error" class="invalid-feedback small">
            Please enter a section name
          </div>
        </div>

        <div class="modal-form-group form-group mb-3">
          <label for="section_order" class="modal-form-label form-label text-xxs">Section Order:</label>
          <input type="number" id="section_order" v-model.number="current_edit_section.order"
            class="modal-form-control form-control text-xxs rounded-3 p-2 shadow-sm mb-3" placeholder="Section Order"
            min="1" @keyup.enter="save_edited_section">
        </div>

        <div v-if="general_error" class="alert alert-danger small mt-2 p-2">
          {{ general_error }}
        </div>
      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
          @click="save_edited_section" :disabled="!current_edit_section.name?.trim()" data-bs-dismiss="modal">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>